import PropTypes from 'prop-types';
import Styled from './circle-indicator-style';

/**
 *
 * @param {object} props -
 * @param {string} props.status -
 * @returns {JSX.Element}
 */
const CircleIndicator = ({ status }) => (
  <Styled.Circle color={status} size={20} />
);

CircleIndicator.propTypes = {
  status: PropTypes.string.isRequired,
};

export default CircleIndicator;
